import {
  GET_TWO_FACTOR_AUTH_WATCHER,
  GET_TWO_FACTOR_AUTH_SUCESS,
  PUT_TWO_FACTOR_AUTH_ACTIVE,
  PUT_TWO_FACTOR_AUTH_ACTIVE_SUCESS,
  PUT_TWO_FACTOR_AUTH_WATCHER,
} from "./constants"

export function getTwoFactorAuthWatcher(payload) {
  return {
    type: GET_TWO_FACTOR_AUTH_WATCHER,
    payload,
  }
}

export function getTwoFactorAuthActiveSucess(payload) {
  return {
    type: GET_TWO_FACTOR_AUTH_SUCESS,
    payload,
  }
}

export function putTwoFactorAuthWatcher(payload) {
  return {
    type: PUT_TWO_FACTOR_AUTH_WATCHER,
    payload,
  }
}

export function putTwoFactorAuth(payload) {
  return {
    type: PUT_TWO_FACTOR_AUTH_ACTIVE,
    payload,
  }
}

export function putTwoFactorAuthActiveSucess(payload) {
  return {
    type: PUT_TWO_FACTOR_AUTH_ACTIVE_SUCESS,
    payload,
  }
}
